import React, {useCallback} from 'react';
import {IconButton, SvgIconTypeMap} from "@mui/material";
import styles from "./FooterButton.module.scss";
import {OverridableComponent} from "@mui/material/OverridableComponent";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";


interface FooterButtonProps {
  isActive?: boolean;
  mainRoute?: string;
  routes?: string[];
  label?: string;
  Icon: OverridableComponent<SvgIconTypeMap>;
}

const FooterButton = ({Icon, mainRoute, routes, label}: FooterButtonProps) => {

  const navigate = useNavigate();
  const location = useLocation();

  const changeRoute = useCallback(() => {
    !!mainRoute && navigate(mainRoute)
  }, [mainRoute, navigate])

  const isActive = useCallback(() => {
    const path = location.pathname;
    if (routes?.some((route) => path.startsWith(route))) {
      return true;
    }
    if (!mainRoute) {
      return false;
    }
    return path === mainRoute || path.startsWith(`${mainRoute}/`);
  }, [location.pathname, mainRoute, routes])


  const active = isActive();
  const shouldDisplayStyleActive = active ? styles['active'] : ''

  return (
    <IconButton
      type={"button"}
      color={"primary"}
      className={`${styles['tab']} ${shouldDisplayStyleActive}`}
      onClick={changeRoute}
      data-tour={label?.toLowerCase()}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
    >
      <Icon className={styles['default-button-icon']}/>
      {label && <span className={styles['label']}>{label}</span>}
    </IconButton>
  );
};

export default FooterButton;
